import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { INotification, NotificationData } from '../notifications.model';
import { resetUnreadNotifications } from '../notifications-api';

interface INotificationState {
  fetchingNotification: boolean;
  unreadNotificationCount: number;
  notificationData: INotification[];
}

const initialState: INotificationState = {
  fetchingNotification: true,
  unreadNotificationCount: 0,
  notificationData: []
};

/* 
  Getting data to display notifications
*/
const resetNotifications = createAsyncThunk('resetNotifications', async () => {
  const response = await resetUnreadNotifications();
  return {
    response
  };
});

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotificationData(
      state,
      action: PayloadAction<{
        notificationData: NotificationData;
      }>
    ) {
      state.unreadNotificationCount =
        action.payload.notificationData.unread_count;
        state.notificationData.unshift(
          ...action.payload.notificationData.notifications
        );
      state.fetchingNotification = false;
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(resetNotifications.pending, (state) => {
        state.fetchingNotification = true;
      })
      .addCase(resetNotifications.fulfilled, (state) => {
        state.fetchingNotification = false;
        state.unreadNotificationCount = 0;
        state.notificationData.filter((data:INotification)=>!data.is_read).forEach((element:INotification) => {
          element.is_read=true
        });
      })
      .addCase(resetNotifications.rejected, (state) => {
        state.fetchingNotification = false;
      })
});

export const { setNotificationData } = notificationSlice.actions;

export { resetNotifications };

export default notificationSlice;
